import React, { useState } from 'react';
import { BsDownload, BsExclamationTriangle } from 'react-icons/bs';
import { useCustomer } from './CustomerContext';
import StatusBadge from './components/StatusBadge';
import EmptyState from './components/EmptyState';
import { apiFetch, parseJsonSafe } from '../../utils/api';

const CustomerDownloadsPage = () => {
  const { licenses, loading, authHeaders } = useCustomer();
  const [downloading, setDownloading] = useState(null);
  const [error, setError] = useState('');

  // Group licenses by product, pick the most recent active one
  const products = {};
  licenses.forEach(l => {
    if (!products[l.product_id] || l.status === 'active') {
      products[l.product_id] = l;
    }
  });
  const productList = Object.values(products);

  const handleDownload = async (license) => {
    setDownloading(license.product_id);
    setError('');
    try {
      const res = await apiFetch(`/api/v1/software/customer/portal/downloads/${encodeURIComponent(license.product_slug || license.product_id)}`, {
        method: 'POST',
        headers: { ...authHeaders(), 'Content-Type': 'application/json' }
      });
      const data = await parseJsonSafe(res);
      if (!res.ok) throw new Error(data.message || 'No se pudo obtener la descarga');
      if (data.download_url) {
        window.location.href = data.download_url;
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setDownloading(null);
    }
  };

  if (loading) return <div className="cp-skeleton cp-skeleton-card" style={{ height: 200 }} />;

  return (
    <div>
      <h1 className="cp-page-title">Descargas</h1>

      {error && <div className="cp-alert cp-alert-error">{error}</div>}

      {!productList.length ? (
        <EmptyState icon={BsDownload} title="Sin descargas disponibles" subtitle="No tienes productos con licencia para descargar." />
      ) : (
        <div className="cp-license-grid">
          {productList.map(l => (
            <div key={l.product_id} className="cp-license-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{l.product_name}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>{l.plan_name}</div>
                </div>
                <StatusBadge status={l.status} />
              </div>

              {l.status !== 'active' ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#f57f17', fontSize: 13, padding: '12px 0' }}>
                  <BsExclamationTriangle /> Licencia no activa. Renueva para descargar.
                </div>
              ) : (
                <button
                  className="cp-btn cp-btn-primary cp-btn-sm"
                  style={{ width: '100%', justifyContent: 'center' }}
                  disabled={downloading === l.product_id}
                  onClick={() => handleDownload(l)}
                >
                  <BsDownload /> {downloading === l.product_id ? 'Preparando...' : 'Descargar ultima version'}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomerDownloadsPage;
